import '../sass/podcast-listing.scss';

(() => {
    const $blocks = document.querySelectorAll('[data-podcast-listing]');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $pageInput = $block.querySelector('.js-podcast-listing-page');
        const $results = $block.querySelector('.js-podcast-listing-results');
        const $pagination = $block.querySelector('.js-podcast-listing-pagination');
        const ajaxUrl = $block.dataset.ajaxUrl;
        const nonce = $block.dataset.nonce;

        if (!$pageInput || !$results || !$pagination || !ajaxUrl || !nonce) return;

        const fetchResults = () => {
            const formData = new FormData();

            formData.append('action', 'blenheim_schools_podcast_listing');
            formData.append('nonce', nonce);
            formData.append('page', $pageInput.value);

            $block.classList.add('podcast-listing--loading');

            fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            }).then(async response => {
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }

                return response.json();
            }).then(json => {
                if (!json.success) return;

                $results.innerHTML = json.data.results;
                $pagination.innerHTML = json.data.pagination;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                $block.classList.remove('podcast-listing--loading');
            });
        };

        $pagination.addEventListener('click', e => {
            const $button = e.target.closest('[data-page]');

            if (!$button || $button.disabled) return;

            $pageInput.value = $button.dataset.page;
            fetchResults();
        });
    });
})();
